module.exports = __webpack_public_path__ + "static/media/vin-id-logo.35981592.png";